'use client'

import { Suspense, useEffect } from "react";
import { useSearchParams, usePathname } from "next/navigation";
import { MemoryRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Home from "@/pages/Home";
import Archetypes from "@/pages/Archetypes";
import MakeGentleTale from "@/pages/MakeGentleTale";
import NotFound from "@/pages/NotFound";

// Синхронизирует внутренний роутер с URL браузера
function UrlSync() {
  const location = useLocation();
  const navigate = useNavigate();

  // React Router навигация → обновляем URL браузера
  useEffect(() => {
    const current = window.location.pathname + window.location.search;
    const next = location.pathname + location.search;
    if (current !== next) {
      window.history.pushState(null, "", next);
    }
  }, [location.pathname, location.search]);

  // Кнопки "Назад"/"Вперёд" браузера → синхронизируем MemoryRouter
  useEffect(() => {
    const handlePopState = () => {
      navigate(window.location.pathname + window.location.search, { replace: true });
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [navigate]);

  return null;
}

function AppWithRouter() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const search = searchParams.toString() ? `?${searchParams.toString()}` : "";

  return (
    <MemoryRouter initialEntries={[`${pathname}${search}`]}>
      <UrlSync />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/archetypes" element={<Archetypes />} />
        <Route path="/make-gentle-tale" element={<MakeGentleTale />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </MemoryRouter>
  );
}

export default function ClientApp() {
  return (
    <Suspense>
      <AppWithRouter />
    </Suspense>
  );
}
